module.exports = __webpack_public_path__ + "static/blockchain-259659a934ca14756eaa73e6a7d62912.svg";